import React from "react";
import { Modal, Box } from "@mui/material";
import useTitanApp from "../../hooks/useTitanApp";
import PrescriptionCarditems from "./components/components/PrescriptionCarditems";

const PrescriptionModal = ({ show, handleClose, handleRemove }) => {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "95%", // Mobile: 95% width
      sm: "85%", // Small tablets: 85% width
      md: "70%", // Medium screens (laptops): 70% width
      lg: "55%", // Large screens: 55% width
      xl: "50%", // Extra large screens: 45% width
      "2xl": "35%", // Very large screens: 35% width (your original)
    },
    maxWidth: "900px", // Maximum width limit
    minWidth: "320px", // Minimum width for usability
    bgcolor: darkMode ? "#222" : "#fff",
    boxShadow: 24,
    borderRadius: "16px",
    maxHeight: "90vh", // Prevent modal from being too tall
    overflow: "auto", // Allow scrolling if content is too long
  };

  return (
    <Modal open={show}>
      <Box sx={style}>
        <PrescriptionCarditems
          handleRemove={handleRemove}
          handleClose={handleClose}
        />
      </Box>
    </Modal>
  );
};

export default PrescriptionModal;
